import { render, staticRenderFns } from "./TextArea.dynamic.vue?vue&type=template&id=ec2e2d10&"
import script from "./TextArea.dynamic.vue?vue&type=script&lang=js&"
export * from "./TextArea.dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports